import React from 'react'
import { Grid, List, Placeholder } from 'semantic-ui-react'
import ImageAvater from '../../../../drive/Components/ImageAvater';

class ActivityCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showNonAccountable: false
        }
    }

    stoPropogation = (e) => {
        e.stopPropagation();
    }

    render() {

        let onlyAccountable = this.props.activityRACIUsers && this.props.activityRACIUsers.filter((item, i) => { return item.role === "Accountable" });
        let nonAccountable = this.props.activityRACIUsers && this.props.activityRACIUsers.filter((item, i) => { return item.role !== "Accountable" });

        return (
            <Grid divided className="pad_10" style={{ minWidth: '200px', minHeight: '70px', }} onClick={(e) => this.stoPropogation(e)} onDoubleClick={(e) => this.stoPropogation(e)}>
                <Grid.Row className="pad_0" style={{ maxHeight: '140px', overflow: 'auto' }}>
                    <List divided verticalAlign='middle' relaxed='very' style={{ width: "100%" }}   >
                        {onlyAccountable && onlyAccountable.length ?
                            onlyAccountable && onlyAccountable.map((item, index) => {
                                setTimeout(() => {
                                    this.setState({ showNonAccountable: true })
                                }, 1000);
                                return <List.Item key={index} className="pad_5">
                                    <ImageAvater user={item} />
                                    <List.Content>
                                        <List.Header >{item.firstName + ' ' + item.lastName}</List.Header>
                                        <List.Description className="f_9">
                                            {item.role}
                                        </List.Description>
                                    </List.Content>
                                </List.Item>
                            }) :
                            <Placeholder>
                                <Placeholder.Header image>
                                    <Placeholder.Line />
                                    <Placeholder.Line />
                                </Placeholder.Header>
                            </Placeholder>
                        }

                        {this.state.showNonAccountable && nonAccountable && nonAccountable.map((item, index) => {
                            return <List.Item key={index} className="pad_5"  >
                                <ImageAvater user={item} />
                                <List.Content>
                                    <List.Header >{item.firstName + ' ' + item.lastName}</List.Header>
                                    <List.Description className="f_9">
                                        {item.role}
                                    </List.Description>
                                </List.Content>
                            </List.Item>

                        })}

                    </List>
                </Grid.Row>
            </Grid>

        )
    }
}

export default ActivityCard;


